
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/history/ticket",
      function () {
        return require("private-next-pages/history/ticket/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/history/ticket"])
      });
    }
  